import script from "./AdminModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminModal.vue?vue&type=style&index=0&id=52fe72cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52fe72cd"]])

export default __exports__